import { render, staticRenderFns } from "./SamMultiChipInput.vue?vue&type=template&id=949162ba&scoped=true&shadow"
import script from "./SamMultiChipInput.vue?vue&type=script&lang=js&shadow"
export * from "./SamMultiChipInput.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamMultiChipInput.vue?vue&type=style&index=0&id=949162ba&prod&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "949162ba",
  null
  ,true
)

export default component.exports